<template lang="pug">
  el-row.row
    el-col(:span="6")
      app-label(:label="label", :required = "true")
    el-col(:span="12")
      validation-provider(rules="required", v-slot="{ errors }" :name="`${name}_${label}`")
        el-input(
          :class="{'erro' : errors.length}"
          v-model="computedContent"
          class="input"
        )
        span.help.erro {{ errors[0] }}
</template>

<script>
import AppLabel from '@/components/AppLabel'

export default {
  components: {
    AppLabel
  },
  props: {
    name: {
      type: String
    },
    label: {
      type: String,
      required: true
    },
    content: {
      type: [String, Number, Array]
    },
    marginBottom: {
      type: Boolean,
      default: false
    },
    marginLeft: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localContent: this.content,
      errors: []
    }
  },
  computed: {
    computedContent: {
      get () {
        return this.localContent
      },
      set (value) {
        this.localContent = value
        this.$emit('update:content', value)
      }
    }
  },
  watch: {
    content (newVal) {
      this.localContent = newVal
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.float-right {
  float: right;
}

.mb {
  margin-bottom: 2vh;
}

.ml {
  margin-left: 15px;
}

.text {
  color: $font-color;
}

p {
  margin-bottom: 1vh;
  font-size: 14px;
  b {
    color: $font-dark-color;
    span{
      font-weight: normal !important;
    }
  }
  min-width: 200px;
}

.icon {
  margin-left: 2px;
  margin-right: 2px;
  color: #b2b6be;
}

.blackLabel {
  color: black
}

.row {
  min-width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.input {
  margin-left: 10px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AppDisplayComInput.vue